import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';

import { CommonVerbsApiService } from '@services/common/common-verbs-api.service';
import { FormField } from '@models/forms/form-field.model';
import { FormFieldGroup } from '@models/forms/form-field-group.model';
import { FormQuestion } from '@models/forms/form-question.model';
import _ from 'lodash';

@Component({ template: '' })
export class FormFieldComponent implements OnInit {
  api: CommonVerbsApiService;
  section: FormField;
  group!: FormFieldGroup;
  question!: FormQuestion;
  formData!: FormGroup;
  questionParams: { required?: boolean; maxLength?: number };

  constructor(public formBuilder: FormBuilder, api: CommonVerbsApiService) {
    this.api = api;
  }

  ngOnInit(): void {
    let questionParams = JSON.parse(this.question.params) ?? '';
    questionParams = questionParams[0];
    this.questionParams = questionParams;
    this.formData = this.formBuilder.group({
      field: [
        this.question.questionType === 'BOOLEAN' ? false : '',
        [
          questionParams?.required === true
            ? Validators.required
            : Validators.nullValidator,
          Validators.maxLength(questionParams?.maxLength),
        ],
      ],
    });

    if (
      (this.group.name === 'relative' ||
        this.group.name === 'people who are important to me') &&
      this.question.reference === 'RELATIVE_TAGS'
    ) {
      const jsonOptions = _.keys(this.question.options[0].jsonValue);
      for (const i in jsonOptions) {
        this.formData.addControl(jsonOptions[i], new FormControl('', []));
      }
    }
  }

  get form() {
    return this.formData.controls;
  }
}
